import createStaticResourceAPI from "@/helpers/rtk_static_resource_factory";
const type = 'PATIENTSEGMENTS';

export const patientsegmentsAPI = createStaticResourceAPI({
    baseURL: `${process.env.REACT_APP_GLOBO_API}/staticdata/patientsegments`,
    resource: "PatientSegments",
    idKey: "patientSegmentId",
    tagTypes: ["GLOBO", "PatientSegments"],
    lookupMap: ({ patientSegmentId, patientSegmentName }) => ({
        value: patientSegmentId,
        label: patientSegmentName,
    }),
    getInvalidationTags: ({ mode, patch }) => {
        const tags = [{ type: type, id: type }];
        if (mode === 'save' || mode === 'delete') {
            tags.push({ type: type, id: patch.patientSegmentId });
        }
        return tags; 
    },
});

export const {
    useGetPatientSegmentsQuery,
    useFindPatientSegmentsQuery,
    useLookUpPatientSegmentsMutation,
    useDeletePatientSegmentsMutation,
    useSavePatientSegmentsMutation,
    useExportPatientSegmentsMutation,
} = patientsegmentsAPI;
